export default "/kiban/_next/static/images/padLess03-a601cabc90f8275dc7bf0eca8c954bdd.png";